$(document).ready(function() {
    if ($('body.page-template-template-homepage').length > 0) {
        homepageSlick();
        homepageSlider();
    }

    if ($('body.single-product').length > 0) {
        productInnerSlider();
        relatedProducts();
    }
});

function homepageSlider() {
    $('.hero-slider.product-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
}

function homepageSlick() {
    $('.homepage-widget-carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}

function productInnerSlider() {
    $('.woocommerce-product-gallery ol.flex-control-nav').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 2,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 2,
                }
            }
        ]
    });
}

function relatedProducts() {
    $('section.related.products ul.products').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}